import React, { useRef, useState } from "react";
import { Button } from "../ui";
import content from "../../services/api-content";
import { useToast } from "../../context/ToastContext";
import "../../styles/content.css";

/** อัปโหลดรูป (ย่อก่อนส่ง ≤5MB) — value = array URL ; รูปแรก = รูปหลัก */
export default function ImageUploader({ value = [], onChange, max = 5, type = "character", label = "เพิ่มรูป" }) {
  const toast = useToast();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (files) => {
    const list = Array.from(files || []).slice(0, max - value.length);
    if (!list.length) return;
    setBusy(true);
    const urls = [];
    for (const f of list) {
      try { urls.push((await content.upload(f, type)).url); } catch (e) { toast(`${f.name}: ${e.message}`, "error"); }
    }
    if (urls.length) onChange([...value, ...urls]);
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const makeMain = (i) => onChange([value[i], ...value.filter((_, j) => j !== i)]);

  return (
    <div>
      <div className="upload-grid">
        {value.map((u, i) => (
          <div className="upload-tile" key={u + i} style={{ cursor: "default" }}>
            <img src={u} alt={`รูปที่ ${i + 1}`} />
            <Button size="sm" icon className="rm" aria-label={`ลบรูปที่ ${i + 1}`} onClick={() => remove(i)}>✕</Button>
            {i === 0 ? <span className="badge badge--feat main-tag">รูปหลัก</span> : <button type="button" className="badge main-tag" style={{ border: 0, cursor: "pointer" }} onClick={() => makeMain(i)}>ตั้งเป็นรูปหลัก</button>}
          </div>
        ))}
        {value.length < max ? (
          <button type="button" className="upload-tile" onClick={() => ref.current?.click()} disabled={busy} aria-label={label}>
            <span style={{ fontSize: 26 }}>{busy ? "⏳" : "＋"}</span>{busy ? "กำลังอัปโหลด" : label}<span className="faint">{value.length}/{max}</span>
          </button>
        ) : null}
      </div>
      <input ref={ref} type="file" hidden multiple={max > 1} accept="image/jpeg,image/png,image/gif,image/webp" onChange={(e) => pick(e.target.files)} />
      <div className="field__hint mt-8">JPG / PNG / GIF / WEBP — ระบบย่อรูปให้อัตโนมัติ (ไม่เกิน 5MB)</div>
    </div>
  );
}
